module.exports = __webpack_public_path__ + "img/back-groud-detail.98d2890c.svg";